import { render, staticRenderFns } from "./contact-acquisition-details.vue?vue&type=template&id=56eae8f5&scoped=true&"
import script from "./contact-acquisition-details.vue?vue&type=script&lang=js&"
export * from "./contact-acquisition-details.vue?vue&type=script&lang=js&"
import style0 from "./contact-acquisition-details.vue?vue&type=style&index=0&id=56eae8f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eae8f5",
  null
  
)

export default component.exports